import { FC, useState } from 'react';
import { Flex, FlexProps, Image } from '@chakra-ui/react';
import chestTokens from '../../assets/images/chest-tokens.png';
import { RewardsActivityCardType, TransactionTypes } from '../../types/RewardsActivityCard';
export interface CbRewardsActivityCardImageProps extends FlexProps {
  imageUrl: RewardsActivityCardType['imageUrl'];
  transactionType: RewardsActivityCardType['transactionType'];
}
export const CbRewardsActivityCardImage: FC<CbRewardsActivityCardImageProps> = ({
  imageUrl,
  transactionType,
  ...props
}) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const image = imageUrl ? imageUrl : chestTokens;
  const imageSize = {
    base: '80px',
    sm: '88px'
  };
  const paddingX = transactionType === TransactionTypes.StorePurchase || transactionType === TransactionTypes.ChestReceived ? 1 : 0;
  return <Flex alignItems="center" justifyContent="center" borderRadius={8} border="1px solid" borderColor="cloud.300" height={imageSize} width={imageSize} minWidth={imageSize} overflow="hidden" paddingX={paddingX} {...props} data-sentry-element="Flex" data-sentry-component="CbRewardsActivityCardImage" data-sentry-source-file="CbRewardsActivityCardImage.tsx">
        <Image data-testid="reward-activity-image" alt="Reward" borderRadius={8} display={hasLoaded ? 'block' : 'none'} height="auto" onLoad={() => setHasLoaded(true)} width={imageSize} src={image} data-sentry-element="Image" data-sentry-source-file="CbRewardsActivityCardImage.tsx" />
      </Flex>;
};